import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "strength", "bar", "rating", "feedback"]
  static values = { minScore: { type: Number, default: 3 } }

  connect() {
    if (typeof zxcvbn === 'undefined') {
      console.error('zxcvbn library not loaded')
    }
  }

  check() {
    const password = this.inputTarget.value

    if (!password || password.length === 0) {
      this.clearStrength()
      return
    }

    if (typeof zxcvbn === 'undefined') {
      console.error('zxcvbn library not loaded')
      return
    }

    const result = zxcvbn(password)
    this.updateStrength(result.score)
    this.updateFeedback(result.feedback)
  }

  updateStrength(score) {
    this.updateBar(score)
    this.updateRating(score)
    this.updateValidity(score)
  }

  updateValidity(score) {
    if (score < this.minScoreValue) {
      this.inputTarget.setCustomValidity(
        `Password is too weak. Must be at least "${this.ratings[this.minScoreValue]}".`
      )
    } else {
      this.inputTarget.setCustomValidity('')
    }
  }

  updateFeedback(feedback) {
    if (this.hasFeedbackTarget) {
      let feedbackHTML = ''

      if (feedback.warning) {
        feedbackHTML += `<p class="text-sm text-orange-700">${feedback.warning}</p>`
      }

      if (feedback.suggestions && feedback.suggestions.length > 0) {
        feedbackHTML += '<ul class="text-sm text-slate-600 list-disc list-inside mt-1">'
        feedback.suggestions.forEach(suggestion => {
          feedbackHTML += `<li>${suggestion}</li>`
        })
        feedbackHTML += '</ul>'
      }

      this.feedbackTarget.innerHTML = feedbackHTML
    }
  }

  clearStrength() {
    if (this.hasBarTarget) {
      this.barTarget.style.width = '0%'
    }

    if (this.hasRatingTarget) {
      this.ratingTarget.textContent = ''
    }

    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = ''
    }

    // Clear validity when field is empty
    this.inputTarget.setCustomValidity('')
  }

  updateBar(score) {
    if (this.hasBarTarget) {
      // Remove all color classes
      this.barTarget.classList.remove(...this.strengthColors)
      // Add current color
      this.barTarget.classList.add(this.strengthColors[score])
      // Update width
      this.barTarget.style.width = `${(score + 1) * 20}%`
    }
  }

  updateRating(score) {
    if (this.hasRatingTarget) {
      this.ratingTarget.textContent = this.ratings[score]
      // Remove all text color classes
      this.ratingTarget.classList.remove(...this.textColors)
      // Add current text color
      this.ratingTarget.classList.add(this.textColors[score])
    }
  }

  get textColors() {
    return [
      'text-red-600',
      'text-orange-600',
      'text-yellow-600',
      'text-lime-600',
      'text-green-600'
    ]
  }

  get strengthColors() {
    return [
      'bg-red-500',
      'bg-orange-500',
      'bg-yellow-500',
      'bg-lime-500',
      'bg-green-500'
    ]
  }

  get ratings() {
    return ['Very Weak', 'Weak', 'Fair', 'Strong', 'Very Strong']
  }
}
